import React from 'react'; // eslint-disable-line
import { select } from 'redux-saga/effects';

// eslint-disable-next-line import/no-cycle
import store from '../store';
import * as actions from '../state';
import favoriteBoardService from './services/board/favoriteBoard';
import fetchBoardListService from './services/board/fetchBoardList';

export default function* favoriteBoard(event) {
  const { board } = event.payload;
  const { intl } = event.payload;
  const failedMsg = event.payload.messages.FAVORITE_FAILED;

  try {
    const user = yield select((state) => actions.readStateUser(state));

    const favoriteService = favoriteBoardService({
      user: user.userId,
      domain: user.domain,
      board,
    });

    favoriteService.then((result) => {
      try {
        if (!result) {
          throw intl.formatMessage({ ...failedMsg });
        }

        fetchBoardListService({ // update boardlist
          user: user.userId,
          domain: user.domain,
        }).then((boardList) => {
          store.dispatch(actions.setBoardList(boardList));
        });
      } catch (error) {
        store.dispatch(actions.showToaster({
          show: true,
          type: 'error',
          message: error,
        }));
      }
    });
  } catch (error) {
    store.dispatch(actions.showToaster({
      show: true,
      type: 'error',
      message: error,
    }));
  }
}
